/**
 * Agent constants for Matrix Studio
 *
 * Centralized constants to avoid magic strings throughout the codebase
 */

export const DEVO_ASSISTANT_NAME = 'Devo Assistant';
export const DEVO_ASSISTANT_ID = '00000000-0000-0000-0000-000000000001';
